import * as React from 'react'
import BaseIcon from 'react-icon-base'

const StreakIcon = props => (
  <BaseIcon width="40" height="40" viewBox="0 0 40 40" {...props}>
    <g fill="none" fillRule="evenodd">
      <rect width="40" height="40" fill="#FDB44D" rx="20" />
      <g fill="#EBEEF0">
        <path fill="none" d="M13 10h13v20H13z" />
        <path
          fill="#FFF"
          fillRule="nonzero"
          d="M18.503 28.333l-.73-.135C16.121 27.89 13 26.405 13 22.977c0-2.823 1.327-4.435 2.862-6.302 1.173-1.425 2.502-3.04 3.68-5.593L20.04 10l.479 1.093c.06.134 1.3 3.008 1.571 6.902.749-1.082 1.155-2.086 1.16-2.1l.479-1.196.513 1.18c.127.291 3.079 7.174 1.043 10.532-.722 1.191-1.945 1.795-3.637 1.795h-.263l-.162-.22a14.695 14.695 0 0 1-2.527-5.55c-.655 2.201-.299 5.084-.294 5.12l.1.777z"
        />
      </g>
    </g>
  </BaseIcon>
)

export default StreakIcon
